






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

interface CatalogCompensation {
    validationDeadline: string;
}

@Component({ components: { } })
export default class Date extends Vue {
    @Prop() public catalogCompensation!: CatalogCompensation;

    public static getNeededFields(): string[] {
        return [
            "catalog.validationDeadline",
            "catalog.crmBudget",
            "catalog.armisBudget",
            "catalog.pressBudget",
            "catalog.emailAcquisitionBudget",
            "catalog.affichageBudget",
            "catalog.factorElevenBudget",
        ];
    }
}
